<template>
  <svg width="68" height="68" viewBox="0 0 68 68" version="1.1" xmlns="http://www.w3.org/2000/svg"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><circle stroke="#B2B2CD" fill="#FFFFFF" cx="34" cy="34" r="33.5"/><g fill="#B2B2CD" fill-rule="nonzero" opacity=".576"><path d="M23.273 25.394c0 5.724 4.64 10.364 10.364 10.364 5.724 0 10.365-4.64 10.365-10.364 0-5.724-4.64-10.364-10.365-10.364-5.724 0-10.364 4.64-10.364 10.364zM16.029 45.12c0 4.224 7.972 7.649 17.806 7.649 9.835 0 17.807-3.425 17.807-7.65 0-4.224-7.972-7.65-17.807-7.65-9.834 0-17.806 3.426-17.806 7.65z"/></g></g></svg>
</template>
<script lang="ts">
import { Vue, Component } from 'vue-property-decorator';
@Component
export default class avatarIcon extends Vue {}
</script>
